import * as actionsModule from './actions';
import * as handlersModule from './handlers';

export namespace MainPage {
  export type Message = actionsModule.Message;
  export type HandlerContext = handlersModule.HandlerContext;
  export const actions = actionsModule;
  export const { handleMessage } = handlersModule;
}
